import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface PropertySpecsProps {
  bedrooms: string;
  bathrooms: string;
  area: string;
  landArea: string;
  setBedrooms: (value: string) => void;
  setBathrooms: (value: string) => void;
  setArea: (value: string) => void;
  setLandArea: (value: string) => void;
}

export function PropertySpecs({
  bedrooms,
  bathrooms,
  area,
  landArea,
  setBedrooms,
  setBathrooms,
  setArea,
  setLandArea,
}: PropertySpecsProps) {
  return (
    <>
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="bedrooms">Quartos</Label>
          <Input
            id="bedrooms"
            type="number"
            value={bedrooms}
            onChange={(e) => setBedrooms(e.target.value)}
            placeholder="Nº de quartos"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="bathrooms">Banheiros</Label>
          <Input
            id="bathrooms"
            type="number"
            value={bathrooms}
            onChange={(e) => setBathrooms(e.target.value)}
            placeholder="Nº de banheiros"
          />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="area">Área Construída (m²)</Label>
          <Input
            id="area"
            type="number"
            value={area}
            onChange={(e) => setArea(e.target.value)}
            placeholder="Área construída"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="landArea">Área do Terreno (m²)</Label>
          <Input
            id="landArea"
            type="number"
            value={landArea}
            onChange={(e) => setLandArea(e.target.value)}
            placeholder="Área do terreno"
          />
        </div>
      </div>
    </>
  );
}